import { getCountryCode } from '@clover/locales';

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const allowedCharactersRegex = /^[ A-Za-z0-9-@.!$()<>,+\w\s]*$/;

// Matches a "first" name with multiple spaces (i.e can be multiple words) limited to 64 characters
export const firstNameWithLengthLimitRegex = /^(\w(\s\w)*){1,64}\s*?$/;

// Matches a "last" name limited to 64 characters
export const lastNameWithLengthLimitRegex = /^(\w{1,64})\s*?$/;

// Matches a Business Name with multiple spaces upto l127 characters length. Business name can not have "!@#$*~ ?" characters.
export const businessNameRegex = /^((?![\^!@#$*~ <>?]).)((?![\^!@#$*~<>?]).){0,125}((?![\^!@#$*~ <>?]).)$/;

// Matches intl phone numbers even more generally
export const phoneNumberRegex = /(?!.*-$)^(\+?\d{1,3})? ?\(?\d{1,5}\)?[- ]?\d{2,9}[- ]?\d{2,4}[- ]?\d{0,2}[- ]?\d{0,2}$/;

export const postalCodeRegex = /^[a-zA-Z0-9]{2,9}$/;

export const zipCodeRegex = /^[a-zA-Z0-9](((?=[^]*[^]*$)[a-zA-Z0-9]{0,8})|((?=[^]* [^]*$)[a-zA-Z0-9]{0,8})){1}[a-zA-Z0-9]$/;

export const validateEmail = (email: string): boolean => {
  return emailRegex.test(email);
};

export const validateNote = (note: string): boolean => {
  return allowedCharactersRegex.test(note);
};

export const getCountryFromLocale = (merchantLocale: string) => {
  let country = '';
  if (merchantLocale) {
    country = getCountryCode(merchantLocale);
  }

  return country;
};

export const validateFirstName = (fname: string): boolean => {
  return firstNameWithLengthLimitRegex.test(fname);
};

export const validateLastName = (lname: string): boolean => {
  return lastNameWithLengthLimitRegex.test(lname);
};

export const validateBusinessName = (businessName: string): boolean => {
  return businessNameRegex.test(businessName);
};

export const validatePhoneNumber = (phone: string): boolean => {
  return phoneNumberRegex.test(phone);
};

export const validateZipCode = (zip: string): boolean => {
  return postalCodeRegex.test(zip) || zipCodeRegex.test(zip);
};

export const lengthCheckRule = (value: string, minLength: number, maxLength: number) => {
  if (!value) return true;

  const { length: valueLength } = value;

  return !(valueLength >= minLength && valueLength <= maxLength);
};

export const formatValueAsPhone = (receivedPhoneNumber: string) => {
  const numericPhoneString = receivedPhoneNumber.match(/\d/g);
  const phoneNumber = numericPhoneString?.join('') || '';

  if (phoneNumber.length === 10) {
    return phoneNumber.replace(/\D+/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  if (phoneNumber.length > 10) {
    return phoneNumber.replace(/[^\d]+/g, '')
      .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
  }

  return phoneNumber;
};
